import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Loader from "../components/Loader";
import OverallLayout from "../layouts/OverallLayout";

import AboutPage from "../pages/AboutPage";
import BlogPage from "../pages/BlogPage";
import ContactUsPage from "../pages/ContactUsPage";

import {
  DOC_ROUTES,
  ENTERPRISE_ROUTES,
  NAV_ROUTES,
  NAV_SUBROUTES,
  UNIVERSAL_ROUTES,
} from "../utils/routes";

const DocsPage = lazy(() => import("../pages/DocsPage"));
const EventPage = lazy(() => import("../pages/EventPage"));
const EventListPage = lazy(() => import("../pages/EventListPage"));
const HomePage = lazy(() => import("../pages/HomePage"));

const AppRoutes = () => {
  return (
    <Router>
      <Suspense fallback={<Loader show={true} />}>
        <Routes>
          <Route exact path="/" element={<OverallLayout />}>
            <Route
              exact
              path={NAV_ROUTES.get("HOME").PATH}
              element={<HomePage />}
            />

            <Route
              exact
              path={`${NAV_ROUTES.get("HOME").PATH}/${
                NAV_SUBROUTES.get("DOCS").PATH
              }`}
              element={<DocsPage />}
            >
              {Array.from(DOC_ROUTES).map(([key, value], index) => {
                return (
                  <Route
                    key={index}
                    path={value.PATH}
                    element={value.ELEMENT}
                  />
                );
              })}

              {Array.from(ENTERPRISE_ROUTES).map(([key, value], index) => {
                return (
                  <Route
                    key={index}
                    path={value.PATH}
                    element={value.ELEMENT}
                  />
                );
              })}

              {Array.from(UNIVERSAL_ROUTES).map(([key, value], index) => {
                return (
                  <Route
                    key={index}
                    path={value.PATH}
                    element={value.ELEMENT}
                  />
                );
              })}
            </Route>

            <Route
              exact
              path={`${NAV_ROUTES.get("HOME").PATH}/${
                NAV_SUBROUTES.get("ABOUT").PATH
              }`}
              element={<AboutPage />}
            />

            <Route
              exact
              path={`${NAV_ROUTES.get("HOME").PATH}/${
                NAV_SUBROUTES.get("BLOG").PATH
              }`}
              element={<BlogPage />}
            />

            <Route
              path={`${NAV_ROUTES.get("HOME").PATH}/${
                NAV_SUBROUTES.get("EVENTS_LIST").PATH
              }`}
            >
              <Route index element={<EventListPage />} />

              <Route
                path={NAV_SUBROUTES.get("EVENT").PATH}
                element={<EventPage />}
              />
            </Route>

            <Route
              path={`${NAV_ROUTES.get("HOME").PATH}/${
                NAV_SUBROUTES.get("CONTACT").PATH
              }`}
              element={<ContactUsPage />}
            />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRoutes;
